import { compose } from "redux";
import classNames from "classnames";
import { connect } from "react-redux";
import Add from "@material-ui/icons/Add";
import React, { PureComponent } from "react";
import Remove from "@material-ui/icons/Remove";

import {
  Grid,
  Button,
  withStyles,
  Typography,
  ButtonGroup,
} from "@material-ui/core";

import { getSummarizedDataStatesFromState } from "app/app.selectors";
import { GROUP_TYPES, ACTIONS } from "features/planner/planner.constants";

const groupTypeToString = {
  [GROUP_TYPES.LOCATION_GROUP]: "Location Group Region",
  [GROUP_TYPES.PLANNING_GROUP]: "Planning Group Region",
};

class GroupsContainerHeader extends PureComponent {
  render() {
    const {
      type,
      classes,
      dataState,
      columnCount,
      addViewGroupColumn,
      deleteViewGroupColumn,
    } = this.props;

    return (
      <Grid container className={classes.groupHeader}>
        <Grid
          container
          wrap="nowrap"
          alignItems="center"
          justifyContent="space-between"
          className={classNames(
            classes.groupHeaderContent,
            classes[`groupHeaderContent-${type}`],
          )}
        >
          <Typography noWrap variant="subtitle1">
            <b>{groupTypeToString[type]}</b>
          </Typography>
          <ButtonGroup
            size="small"
            variant="contained"
            disabled={dataState.isLoading()}
          >
            <Button title="Remove last column" onClick={deleteViewGroupColumn}>
              <Remove fontSize="small" />
            </Button>
            <Button disabled className={classes.columnCount}>
              {columnCount}
            </Button>
            <Button title="Add column" onClick={addViewGroupColumn}>
              <Add fontSize="small" />
            </Button>
          </ButtonGroup>
        </Grid>
      </Grid>
    );
  }
}

const styles = theme => ({
  groupHeader: {
    marginBottom: 8,
    padding: `0 ${theme.spacing(1)}px`,
  },
  groupHeaderContent: {
    padding: theme.spacing(1),
    background: theme.palette.grey[100],
  },
  [`groupHeaderContent-${GROUP_TYPES.LOCATION_GROUP}`]: {
    flexDirection: "row-reverse",
  },
  [`groupHeaderContent-${GROUP_TYPES.PLANNING_GROUP}`]: {
    flexDirection: "row",
  },
  columnCount: {
    "&.Mui-disabled": {
      background: theme.palette.grey[100],
      color: theme.palette.text.secondary,
    },
  },
});

export default compose(
  connect(state => ({
    dataState: getSummarizedDataStatesFromState(
      state,
      ACTIONS.UPDATE_VIEW_GROUPS_ORDER,
    ),
  })),
  withStyles(styles),
)(GroupsContainerHeader);
